import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 24px;
  text-align: center;
`;

export const Title = styled.h2`
  margin: 0 0 8px;
  color: #1f1f1f;
`;

export const Message = styled.p`
  margin: 0 0 16px;
  max-width: 560px;
  color: #595959;
  word-break: break-word;
`;

export const Reason = styled.div`
  margin: 0 0 24px;
  max-width: 640px;
  width: 100%;
  padding: 12px 16px;
  border-radius: 6px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  color: #a8071a;
  font-size: 13px;
  text-align: left;
`;

export const ReasonLabel = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

export const ReasonBody = styled.pre`
  margin: 0 0 12px;
  font-family: inherit;
  white-space: pre-wrap;
  word-break: break-word;

  &:last-child {
    margin-bottom: 0;
  }
`;
